// i18n initialisation. The marketing surface is the first to migrate;
// app-shell strings will follow incrementally as we touch each page.
//
// Pattern for adding a new translatable string:
//   1. Pick a semantic key (e.g. `marketing.hero.title`, not `string_1`).
//      Group by surface so future locale files stay scannable.
//   2. Add the English value to `locales/en.json`.
//   3. In the component, `const { t } = useTranslation()` and render `t('marketing.hero.title')`.
//
// No translation work yet — only en.json exists. When we add a second
// locale (e.g. `fr.json`), drop it next to `en.json` and add it to the
// `resources` block below. i18next picks the active locale from the
// browser's `navigator.language` with fallback to English.
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes
  },
  // Avoid React Suspense for the marketing page — strings load synchronously
  // from the imported JSON above.
  react: { useSuspense: false },
})

export default i18n
